'use strict'

var Backbone = require('backbone')
var Marionette = require('marionette')
var App = require('app')

/* Views */
var List = require('./list')
var EditNew = require('./edit_new')

var ClientApiKeysList = function () {
  /* Routes ----------------------------------------------------------------- */
  /* API -------------------------------------------------------------------- */
  var API = {
    listApiKeys: function (options) {
      new List(options)
    },
    editApiKey: function (options) {
      new EditNew(options)
    }
  }

  /* Listeners -------------------------------------------------------------- */
  App.globalChannel.on('client-apikeys:list', function (options) {
    API.listApiKeys(options)
  })

  App.globalChannel.on('client-apikeys:new', function (options) {
    API.editApiKey(options)
  })

  App.globalChannel.on('client-apikeys:edit', function (options) {
    API.editApiKey(options)
  })
}

module.exports = ClientApiKeysList



// WEBPACK FOOTER //
// ./js/modules/client-apikeys/index.js